const initListingWidthFilters = () => {
    const listingWithFiltersWidgetList = document.querySelectorAll("[data-listing-with-filters-widget]");
    if (listingWithFiltersWidgetList && listingWithFiltersWidgetList.length > 0) {
        const numberOfSelectedOptions = 0;
        listingWithFiltersWidgetList.forEach((listingWithFiltersWidget) => {
            const tabContainer = listingWithFiltersWidget.querySelector("[data-tab-container]");
            const selectionContainerList = listingWithFiltersWidget.querySelectorAll("[data-selection-container]");
            const btnFilter = listingWithFiltersWidget.querySelector("[data-btn-filter]");
            const productFilter = listingWithFiltersWidget.querySelector("[data-tab='product-filter']");
            const searchFilter = listingWithFiltersWidget.querySelector("[data-tab='search-filter']");
            toggleTab(tabContainer, productFilter, searchFilter);
            toggleOptionsContainer(selectionContainerList, numberOfSelectedOptions);
            filter(selectionContainerList, btnFilter);
        });
    }
};
const toggleTab = (tabContainer, productFilter, searchFilter) => {
    const dataTabList = tabContainer.querySelectorAll("[data-tab]");
    dataTabList.forEach((dataTab) => {
        dataTab.addEventListener("click", () => {
            for (let i = 0; i < dataTabList.length; i++) {
                dataTabList[i].classList.remove("active");
            }
            dataTab.classList.add("active");
            if (dataTab.getAttribute("data-tab") == "product-filter-tab") {
                searchFilter.classList.remove("active");
                productFilter.classList.add("active");
            }
            else {
                productFilter.classList.remove("active");
                searchFilter.classList.add("active");
            }
        });
    });
};
const toggleOptionsContainer = (selectionContainerList, numberOfSelectedOptions) => {
    selectionContainerList.forEach((selectionContainer) => {
        const selectedOption = selectionContainer.querySelector("[data-selected-options]");
        const optionContainer = selectionContainer.querySelector("[data-options]");
        const singleOptionList = optionContainer.querySelectorAll("[data-single-option]");
        toggleCounter(singleOptionList, numberOfSelectedOptions, selectedOption);
        selectedOption.addEventListener("click", () => {
            if (optionContainer.classList.contains("active")) {
                optionContainer.classList.remove("active");
            }
            else {
                for (let i = 0; i < selectionContainerList.length; i++) {
                    const resetOption = selectionContainerList[i].querySelector("[data-options]");
                    resetOption.classList.remove("active");
                }
                optionContainer.classList.add("active");
                singleOptionList.forEach((singleOption) => {
                    singleOption.addEventListener("change", () => {
                        onlyOneCheckbox(singleOptionList, singleOption);
                        toggleCounter(singleOptionList, numberOfSelectedOptions, selectedOption);
                    });
                });
            }
        });
    });
};
const onlyOneCheckbox = (singleOptionList, singleOption) => {
    if (singleOption.checked == false) {
        singleOption.checked = false;
    }
    else {
        for (let i = 0; i < singleOptionList.length; i++) {
            singleOptionList[i].checked = false;
        }
        singleOption.checked = true;
    }
};
const toggleCounter = (singleOptionList, numberOfSelectedOptions, selectedOption) => {
    let inputArray = [];
    inputArray = [...inputArray, ...Array.from(singleOptionList)];
    const arr = inputArray.filter(x => x.checked == true);
    numberOfSelectedOptions = arr.length;
    const selectText = selectedOption.querySelector("[data-select-text]");
    const selectNumberText = selectedOption.querySelector("[data-select-number-text]");
    const numberText = selectNumberText.querySelector("[data-number]");
    if (numberOfSelectedOptions != 0) {
        selectText.setAttribute("data-select-text", "");
        selectNumberText.setAttribute("data-select-text", "show");
        numberText.innerHTML = numberOfSelectedOptions.toString();
    }
    else {
        selectText.setAttribute("data-select-text", "show");
        selectNumberText.setAttribute("data-select-text", "");
    }
};
const filter = (selectionContainerList, btnFilter) => {
    btnFilter.addEventListener("click", (e) => {
        e.preventDefault();
        const url = new URL(window.location.href.replace(window.location.search, ''));
        selectionContainerList.forEach((selectionContainer) => {
            const filter = selectionContainer.getAttribute("data-parameter-name");
            const options = selectionContainer.querySelectorAll("[data-single-option]");
            options.forEach((option) => {
                if (option.checked == true) {
                    url.searchParams.append(`${filter}`, `${option.getAttribute('id')}`);
                }
            });
        });
        fetch(`${url.href}`)
            .then(data => {
            //convert the response into plain text
            data.text()
                //resolve the promise
                .then((result) => {
                // Initialize the DOM parser
                const parser = new DOMParser();
                // Parse the text and convert it into HTML
                const parsedHTML = parser.parseFromString(result, "text/html");
                //get only the cards
                const containerToAppendArray = parsedHTML.querySelectorAll("[data-container-to-append]");
                //append them to the deck
                const dataContainer = document.querySelector(`[data-cards-loadmore-container]`);
                const cardsArray = parsedHTML.querySelectorAll("[data-to-append]");
                dataContainer.innerHTML = "";
                containerToAppendArray.forEach(containerToAppend => {
                    dataContainer.append(containerToAppend);
                });
                //add animation
                const configCardsAnimationLoadMore = new ConfigCardsAnimation();
                configCardsAnimationLoadMore.delay = 300;
                configCardsAnimationLoadMore.cardsToAnimateNodeList = cardsArray;
                const cardAnimationLoadMore = new CardAnimation;
                cardAnimationLoadMore.initCardsAnimation(configCardsAnimationLoadMore);
                initLoadMore();
            });
        });
        window.history.replaceState(null, null, `${url.href}`);
    });
};
